import React, { act, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import TableInputCertificate from '../../../component/Produzioni/TableInputCertificate';
import Scanner from '../../../component/Produzioni/Scanner';
import BlockChain from '../../../component/Produzioni/BlockChain';

const TraccibilitaeCertificazioni = ({option, activeStep, setActiveStep }) => {
    const [open, setOpen] = useState(false)

    const data = {
        id: 1,
        title: "Traccibilita e certificazioni",
        description:
            "Registra ogni passaggio con precisione per garantire qualità, conformità e trasparenza nella filiera produttiva.",
        buttonText: "Completa fase",
    };

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <TableInputCertificate 
                option={option} 
                activeStep={activeStep}
                setActiveStep={setActiveStep}
            />
            {open ? <BlockChain /> : <Scanner setOpen={setOpen} setActiveStep={setActiveStep} activeStep={activeStep} />}


        </>
    )
}

export default TraccibilitaeCertificazioni